export const routes = {
	home: () => "/",
	transactions: () => "/transactions",
	transactionReceipt: ({ invoiceId }: { invoiceId: number }) => `/transactions/${invoiceId}`,
	account: () => "/account",
	accountEdit: () => "/account/edit",
	accountChangePassword: () => "/account/change-password",
	accountVehicles: () => "/account/vehicles",
	accountVehicleCreate: () => "/account/vehicles?action=create",
	accountVehicleEdit: ({ vehicleId }: { vehicleId: string | number }) => `/account/vehicles?vehicleId=${vehicleId}`,
	sessionLookup: ({ eventId }: { eventId?: string } = {}) =>
		eventId ? `/support/confirmation?eventId=${eventId}` : "/support/confirmation",
	registrationConfirmation: ({ publicIdentifier }: { publicIdentifier: string }) =>
		`/v2/support/confirmation/${publicIdentifier}`,
	permitConfirmation: ({ publicIdentifier }: { publicIdentifier: string }) => `/confirmation/${publicIdentifier}`,
	permits: () => "/permits",
	permitDetails: ({ publicIdentifier, print = false }: { publicIdentifier: string; print?: boolean }) =>
		`/permits/${publicIdentifier}${print ? "?print=true" : ""}`,
	permitAdd: () => "/permits/add",
	permitRequest: ({ publicIdentifier }: { publicIdentifier: string }) => `/requests/${publicIdentifier}`,
	permitRequestPayment: ({ publicIdentifier }: { publicIdentifier: string }) =>
		`/requests/${publicIdentifier}/payment`,
	login: ({ redirectTo }: { redirectTo?: string } = {}) => {
		if (redirectTo) {
			const searchParams = new URLSearchParams({ redirectTo });
			return `/login?${searchParams.toString()}`;
		}
		return "/login";
	},
	logout: ({ redirectTo }: { redirectTo?: string } = {}) => {
		if (redirectTo) {
			const searchParams = new URLSearchParams({ redirectTo });
			return `/logout?${searchParams.toString()}`;
		}
		return "/logout";
	},
	signup: ({ redirectTo, source }: { redirectTo?: string; source?: string } = {}) => {
		const searchParams = new URLSearchParams({
			...(redirectTo ? { redirectTo } : {}),
			...(source ? { source } : {}),
		});
		const query = searchParams.toString();
		return query ? `/signup?${query}` : "/signup";
	},
	forgotPassword: ({ redirectTo }: { redirectTo?: string } = {}) => {
		if (redirectTo) {
			const searchParams = new URLSearchParams({ redirectTo });
			return `/forgot-password?${searchParams.toString()}`;
		}
		return "/forgot-password";
	},
	resetPassword: ({ redirectTo }: { redirectTo?: string } = {}) => {
		if (redirectTo) {
			const searchParams = new URLSearchParams({ redirectTo });
			return `/reset-password?${searchParams.toString()}`;
		}
		return "/reset-password";
	},
	authCallback: ({ state }: { state?: string } = {}) => {
		if (state) {
			const searchParams = new URLSearchParams({ state });
			return `/auth/callback?${searchParams.toString()}`;
		}
		return "/auth/callback";
	},
	authPopupComplete: ({ popupId }: { popupId?: string } = {}) => {
		if (popupId) {
			const searchParams = new URLSearchParams({ popupId });
			return `/auth/popup-complete?${searchParams.toString()}`;
		}
		return "/auth/popup-complete";
	},
	event: ({ eventId }: { eventId: string }) => `/events/${eventId}`,
	terms: ({ publicIdentifier }: { publicIdentifier: string }) => `/terms/${publicIdentifier}`,
	verifyEmail: ({ id, token, redirectTo }: { id: string; token: string; redirectTo?: string }) => {
		const searchParams = new URLSearchParams({ id, token });
		if (redirectTo) {
			searchParams.set("redirectTo", redirectTo);
		}
		return `/verify-email?${searchParams.toString()}`;
	},
	mfaEnroll: ({ userId, token, redirectTo }: { userId: string; token: string; redirectTo?: string }) => {
		const searchParams = new URLSearchParams({ userId, token });
		if (redirectTo) {
			searchParams.set("redirectTo", redirectTo);
		}
		return `/mfa-enroll?${searchParams.toString()}`;
	},
	mfa: ({ factorId, token, redirectTo }: { factorId: string; token: string; redirectTo?: string }) => {
		const searchParams = new URLSearchParams({ factorId, token });
		if (redirectTo) {
			searchParams.set("redirectTo", redirectTo);
		}
		return `/mfa?${searchParams.toString()}`;
	},
	park: ({ locationLookupId }: { locationLookupId: string }) => `/park/${locationLookupId}`,
	locationLookup: ({ lookup, ref }: { lookup: string; ref?: string }) =>
		ref !== undefined ? `/location/${lookup}?ref=${encodeURIComponent(ref)}` : `/location/${lookup}`,
	locationIdentifier: ({ identifier }: { identifier: string }) => `/${identifier}`,
	locationTenant: ({ identifier, tenantId }: { identifier: string; tenantId: string | number }) =>
		`/${identifier}/${tenantId}`,
	codeCheck: ({
		location,
		tenant,
		identifier,
		permitTypeId,
		settingId,
	}: {
		location?: string;
		tenant?: number;
		identifier?: string;
		permitTypeId?: number;
		settingId?: number;
	} = {}) => {
		const params = new URLSearchParams();
		if (location) {
			params.set("location", location);
		}
		if (tenant) {
			params.set("tenant", String(tenant));
		}
		if (identifier) {
			params.set("identifier", identifier);
		}
		if (permitTypeId) {
			params.set("permitTypeId", String(permitTypeId));
		}
		if (settingId) {
			params.set("settingId", String(settingId));
		}
		const qs = params.toString();
		return qs ? `/support/code?${qs}` : "/support/code";
	},
};
